module.exports = __webpack_public_path__ + "static/media/edit-pencil.94998705.svg";